import { APP } from '@/constants';
import { handleResponseWithPagination } from '@/helpers';
import { CustomPageable } from '@/models/custom-pageable.model';
import { CustomResponse } from '@/models/custom-response.model';
import { CustomTableParams } from '@/models/custom-table-params.model';
import { CustomUser } from '@/models/custom-user.model';
import axios from 'axios';

export const UserService = {
    create,
    list,
    remove,
    get,
    update,
    updateMe,
};

function create(user: any): Promise<CustomResponse<CustomUser>> {
    return axios.post(`${APP.API_URL}/users`, user)
        .then(handleResponse)
        .then((response: CustomResponse<CustomUser>) => {
            response.data = new CustomUser(response.data);
            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function remove(id: number): Promise<CustomResponse<any>> {
    return axios.delete(`${APP.API_URL}/users/${id}`)
        .then(handleResponse);
}

function get(id: number): Promise<CustomResponse<CustomUser>> {
    return axios.get(`${APP.API_URL}/users/${id}`)
        .then(handleResponse)
        .then((response: CustomResponse<CustomUser>) => {
            response.data = new CustomUser(response.data);
            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function update(user: CustomUser): Promise<CustomResponse<CustomUser>> {
    return axios.patch(`${APP.API_URL}/users/${user.id}`, user)
        .then(handleResponse)
        .then((response: CustomResponse<CustomUser>) => {
            response.data = new CustomUser(response.data);
            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function updateMe(user: CustomUser): Promise<CustomResponse<CustomUser>> {
    return axios.patch(`${APP.API_URL}/users/me`, user)
        .then(handleResponse)
        .then((response: CustomResponse<CustomUser>) => {
            response.data = new CustomUser(response.data);
            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function list(params?: CustomTableParams): Promise<CustomResponse<CustomPageable>> {

    return axios.get(
        `${APP.API_URL}/users`,
        { params },
    )
        .then(handleResponse)
        .then(handleResponseWithPagination)
        .then((response: CustomResponse<CustomPageable>) => {

            const users: CustomUser[] = response.data.content.map((user: any) => {
                return new CustomUser(user);
            });

            response.data.content = users;

            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function handleResponse(response: any): CustomResponse<any> {
    return response.data;
}

